// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"classes_buttonsContainer__3oksO","bottomSpace":"classes_bottomSpace__2s2Qh"};